import { createContext } from 'react';
import type { StoreApi } from 'zustand';

import type { ConfiguratorStore } from '../types';

export const ConfiguratorStoreContext =
  createContext<StoreApi<ConfiguratorStore> | null>(null);
